module.exports = __webpack_public_path__ + "static/20-17-02f0cb7e9bcff1acde91098654870b6c.jpg";